export default "__VITE_ASSET__DG1FTngf__"